import { useTranslation } from "react-i18next";
import React from "react";
import { MobileMenu } from "@/data/types";
import Image from "next/image";
import planeIcon from "@/images/icons/plane.svg";
import transferIcon from "@/images/icons/transfer.svg";
import businessIcon from "@/images/icons/business-trip.svg";
import cruiseIcon from "@/images/icons/cruise.svg";
import experiencesIcon from "@/images/icons/experiences.svg";

export const useMenu = (): MobileMenu[] => {
  const { t } = useTranslation("guydeez");

  return [
    {
      name: t("airport_pickup"),
      description: t("airport_pickup_description"),
      href: "/airport-pickup",
      icon: () => <Image src={planeIcon} alt="Gift Card" width={40} height={40} /> 
    },
    {
      name: t("transfer"),
      description: t("transfer_description"),
      href: "/transfer",
      icon: () => <Image src={transferIcon} alt="Gift Card" width={40} height={40} /> 
    },
    {
      name: t("business_trip"),
      description: t("business_trip_description"),
      href: "/business-trip",
      icon: () => <Image src={businessIcon} alt="Gift Card" width={40} height={40} /> 
    },
    {
      name: t("cruises"),
      description: t("cruises_description"),
      href: "/cruise-tour",
      icon: () => <Image src={cruiseIcon} alt="Gift Card" width={40} height={40} /> 
    },
  ];
};
